// @TODO: this file is to make old stuff work as expected - eventually we should
// migrate to the new standard for headings
import { HeadingSmall } from 'src/design/components/heading/Headings';
const SubHeading = ({ children, ...props }) => <HeadingSmall {...props}><h2>{children}</h2></HeadingSmall>;
export default SubHeading;
